
































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import Pagination from "@/components/paginaiton.vue";
import QuestionTable from "./question-table.vue";
import { GetQuestionList$, GetAllCates$, ComposeTest$ } from "@/request/jxgl";
@Component({
  components: {
    Pagination,
    QuestionTable,
  },
})
export default class SjkAddSelectDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private test: any;
  private t: any = {
    手动选择: [],
  };
  private filters: any = {
    cate_id: "",
    题目难度: "",
    search: "",
    current_page: 1,
    total_count: 0,
    page_count: 10,
    order_value: 0,
  };
  private cates: any[] = [];
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 列表
  private questions: any[] = [];
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  // 获得全部题型列表
  private fetchAllCate() {
    GetAllCates$(this).then((data) => {
      // console.log(data);
      this.cates = data;
    });
  }
  // 选中改变
  private selectChange(value, item) {
    if (item.selected) {
      this.selectedMessages.push(item);
      this.selectedMessages = _.uniqBy(this.selectedMessages, "question_id");
    } else {
      const index = _.findIndex(this.selectedMessages, "question_id");
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 获得试题列表
   */
  private fetchQuestionList() {
    const params = _.cloneDeep(this.filters);
    GetQuestionList$(this, params).then((data: any) => {
      data.questions.forEach((question: any) => {
        const inc = _.findIndex(this.selectedMessages, (i) => {
          return i["question_id"] === question["question_id"];
        });
        if (inc !== -1) {
          question["selected"] = true;
        } else {
          question["selected"] = false;
        }
      });
      this.$set(this, "questions", data.questions);
      this.filters.total_count = data.total_count;
    });
  }
  /**
   * @description 改变排序顺序
   */
  private changeOrderValue() {
    this.filters.order_value = this.filters.order_value === 0 ? 1 : 0;
    this.search();
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.current_page = 1;
    this.fetchQuestionList();
  }
  /**
   * @description 全选
   */
  private selectAll() {
    this.questions.forEach((question: any) => {
      question["selected"] = true;
      this.selectedMessages.push(question);
    });
    this.selectedMessages = _.uniqBy(this.selectedMessages, "question_id");
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.current_page = val;
    this.fetchQuestionList();
  }
  /**
   * @description 单个添加
   */
  private addOne(question) {
    this.t["手动选择"] = [question["question_id"]];
    ComposeTest$(this, this.t).then((data: any) => {
      this.t["test_id"] = data.test_id;
      this.$emit("testChange", data["test_id"]);
      this.$message.success("添加成功");
    });
  }
  /**
   * @description 关闭
   */
  private cancel() {
    this.$emit("update:ifVisible", false);
  }
  /**
   * @description 保存
   */
  private save() {
    this.t["手动选择"] = [];
    if (this.selectedMessages.length === 0) {
      this.$message.warning("请至少选择一个题目");
      return;
    }
    this.selectedMessages.forEach((question: any) => {
      this.t["手动选择"].push(question["question_id"]);
    });
    ComposeTest$(this, this.t).then((data: any) => {
      this.t["test_id"] = data.test_id;
      this.$emit("testChange", data["test_id"]);
      this.$message.success("添加成功");
      this.$emit("update:ifVisible", false);
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchAllCate();
    this.fetchQuestionList();
    this.t["试卷名称"] = this.test["试卷名称"];
    this.t.test_id = this.test.test_id;
  }
}
